import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgImage = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 12.7218L7.28326 10.5506L12.8253 17H17V5H5V12.7218ZM5 15.4817V17H10.1884L7.13721 13.4494L5 15.4817ZM3 3H19V19H3V3ZM13 10C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10ZM13 12C11.3431 12 10 10.6569 10 9C10 7.34315 11.3431 6 13 6C14.6569 6 16 7.34315 16 9C16 10.6569 14.6569 12 13 12Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgImage);

export default ForwardRef;
